import $http from '../../../axios-instance';

/**
 * Método para guardar identificación de peligros a la salud.
 *
 * @param Object commit
 * @param int|null productId
 */
export async function storeDetailsPreventiveMedicineByProductId({ commit, state }, productId) {

    if (!productId) {
        showMessageProductNotFoundId();
        return false;
    }

    commit("dashboard/load", true, { root: true });
    state.selectedIdentificacionPe.id_producto = productId;

    await $http.post('products/preventive-medicine/store', state.selectedIdentificacionPe)
        .then(({data: response}) => {
            this.$vue.$alertSuccess(response.message);
            commit('productos/setProductoNuevo', false, {root: true});
        })
        .catch(errors => {
            if (this.$vue.$alertErrorsCallback(errors)) return;
            this.$vue.$alertError(errors.message);
        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Medicina preventiva- Obtener los detalles por producto.
 *
 * @param Object commit
 * @param int|null productId
 */
export async function getDetailsPreventiveMedicineByProductId({commit}, productId) {
    if (!productId) {
        showMessageProductNotFoundId();
        return false;
    }

    commit("dashboard/load", true, { root: true });

    await $http.get(`products/preventive-medicine/get-details/product/${productId}`)
        .then(({data: response}) => {
            commit('limpiarIdentificacionPe');
            if (response.data) commit('setIdentificacionPe', response.data);
            else commit('limpiarIdentificacionPe'); 
        })
        .catch(errors => this.$vue.$alertError(errors.message))
        .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Muestra un mensaje de alerta sobre producto erróneo. 
 */
function showMessageProductNotFoundId() {
    this.$vue.$alertError("El producto que intentas procesar está presentando problemas, por favor inténtalo de nuevo.")
}
